var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"text-capitalize",attrs:{"pill":"","variant":("light-" + (_vm.recordStatusVariant(_vm.data)))}},[_vm._v(" "+_vm._s(_vm.recordStatusFormat(_vm.data))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }